var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 40C31.046 40 40.0003 31.0457 40.0003 20C40.0003 8.95429 31.046 -1.52588e-05 20.0003 -1.52588e-05C8.95461 -1.52588e-05 0.000305176 8.95429 0.000305176 20C0.000305176 31.0457 8.95461 40 20.0003 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 20C6.10352e-05 31.0456 8.95443 40 20.0001 40C20.0001 32.3942 20.0001 20 20.0001 20C20.0001 20 6.95654 20 6.10352e-05 20Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 -7.62939e-06C31.0456 -7.62939e-06 39.9999 8.95437 39.9999 20C32.3941 20 19.9999 20 19.9999 20C19.9999 20 19.9999 6.95648 19.9999 -7.62939e-06Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9054 6.95647L13.2004 10.9423H17.3913L14.0008 13.4055L15.2958 17.3913L11.9054 14.928L8.5149 17.3913L9.8099 13.4055L6.41943 10.9423H10.6103L11.9054 6.95647Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0947 22.6087L29.3898 26.5945H33.5806L30.1901 29.0577L31.4852 33.0435L28.0947 30.5802L24.7042 33.0435L25.9992 29.0577L22.6088 26.5945H26.7996L28.0947 22.6087Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanama);
export default __webpack_public_path__ + "static/media/panama.1edce7e42572a5f87c37f06e9a67e088.svg";
export { ForwardRef as ReactComponent };